'use client';
import {MapContainer, TileLayer, Marker, Popup, useMapEvents} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import MarkerCluster from "./MarkerCluster";
import {useMap} from "react-leaflet/hooks";
import {useEffect, useState} from "react";
import {Icon} from "leaflet/src/layer";


const userIcon = new Icon({
    iconUrl: 'https://img.icons8.com/doodle/48/user.png',
    iconSize: [38, 45],
    iconAnchor: [19, 45], // centre horizontalement, bas de l’icône
    popupAnchor: [0, -45] // le popup part du haut du marqueur
});

const wolfIcon = new Icon({
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/3819/3819568.png',
    iconSize: [38, 45],
    iconAnchor: [19, 45],
    popupAnchor: [0, -45]
});



// Correction des icônes Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export function GameMap({markers, isGameMaster, players}) {


    markers = markers.filter(function (element) {
        return element !== undefined;
    });
    console.log(markers);
    console.log(players);
    const [center, setCenter] = useState([48.584330, 2.598819]);

    useEffect(() => {
        setCenter([players[0].position?.lat, players[0].position?.lng]);
    }, []);

    function ChangeView({ center }) {
        const map = useMap();
        const currentZoom = map.getZoom(); // conserve le zoom actuel
        map.setView(center, currentZoom); // on ne touche plus au zoom
        return null;
    }

    return (
        <MapContainer className={"mt-5"}
                      center={isGameMaster ? [48.584330, 2.598819] : [players[0].position?.lat, players[0].position?.lng]}
                      zoom={16} style={{height: '60vh', width: '100%', zIndex: 1, marginBottom: "50px"}}>
            <ChangeView center={center}/>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>

            <MarkerCluster markers={players}/>
            Affichage des joueurs
            {players && players.map((player) => (
                player.position && (
                    <Marker
                        key={player.id}
                        position={[player.position?.lat, player.position?.lng]}
                        icon={isGameMaster ? player.role === "loup" ? wolfIcon : userIcon : userIcon}
                    >
                        <Popup>{player.name}</Popup>
                    </Marker>
                )
            ))}

            {/* Affichage des points GPS du game master */}
            {markers && markers.map((marker, index) => (
                <Marker key={`marker-${index}`} position={[marker?.lat, marker?.lng]}>
                    <Popup>Point GPS #{index + 1}</Popup>
                </Marker>
            ))}
        </MapContainer>
    );
}